"use strict";
exports.__esModule = true;
require("./graphic");
var zrender_1 = require("../zrender");
var Painter_1 = require("./Painter");
zrender_1.registerPainter('canvas', Painter_1["default"]);
